<kendo-card width="100%">
  <kendo-card-body>
    <mat-drawer-container (backdropClick)="close()" autosize>
      <mat-drawer
        #drawer
        position="end"
        mode="over"
        (keydown.escape)="close()"
        disableClose
      >
        <content-details>
          <div *ngIf="contentDetails">
            <ul>
              <li
                *ngIf="
              contentDetails?.deployment_requirements.searchable_data?.length
            "
              >
                <span>Searchable Data</span>
                <p>
                  {{
                  contentDetails.deployment_requirements.searchable_data.join(
                  ', ' ) }}
                </p>
              </li>
              <li
                *ngIf="
              contentDetails?.deployment_requirements.deployment_steps?.length
            "
              >
                <span>Deployment Steps</span>
                <p>
                  <cyborg-markdown
                    [md]="contentDetails.deployment_requirements.deployment_steps"
                  ></cyborg-markdown>
                </p>
              </li>
              <li>
                <span>Emulation & Validation</span>
                <pre>{{ deployItem.huntPackage.validation }}</pre>
              </li>
            </ul>
          </div>
          <div *ngIf="generatedContentDetails">
            <div *ngFor="let content of generatedContentDetails.content">
              <strong
                >{{ generatedContentDetails.tool | uppercase }} - {{
                content.category | uppercase }}</strong
              >
              <pre>
              {{ content.query }}
            </pre
              >
            </div>
          </div>
          <div *ngIf="latestHuntPackageChangeLog">
            <strong>Hunt Package ChangeLog:</strong>
            <ul>
              <li>
                <span>Date:</span>
                <p>{{latestHuntPackageChangeLog.date | date }}</p>
              </li>
              <li>
                <span>Note:</span>
                <p>{{latestHuntPackageChangeLog.note }}</p>
              </li>
            </ul>
            <strong>Content ChangeLog:</strong>
          </div>
          <div *ngIf="latestContentChangeLog" class="content-changelog">
            <table
              mat-table
              [dataSource]="latestContentChangeLog"
              class="mat-elevation-z8"
            >
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>Date</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.date | date }}
                </td>
              </ng-container>

              <ng-container matColumnDef="tool">
                <th mat-header-cell *matHeaderCellDef>Tool</th>
                <td mat-cell *matCellDef="let element">{{ element.tool }}</td>
              </ng-container>

              <ng-container matColumnDef="goal">
                <th mat-header-cell *matHeaderCellDef>Goal</th>
                <td mat-cell *matCellDef="let element">{{ element.goal }}</td>
              </ng-container>

              <ng-container matColumnDef="categories">
                <th mat-header-cell *matHeaderCellDef>Categories</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.categories }}
                </td>
              </ng-container>

              <ng-container matColumnDef="note">
                <th mat-header-cell *matHeaderCellDef>Note</th>
                <td mat-cell *matCellDef="let element">{{ element.note }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>
        </content-details>
      </mat-drawer>
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <package-header>
              <header-title>
                <a
                  routerLink="/research/hunt-package/{{ deployItem.huntPackageUUID }}"
                  >{{ deployItem.huntPackage.title}}</a
                >
              </header-title>
              <header-options>
                <severity
                  class="{{ deployItem.huntPackage.severity | lowercase }}"
                  >{{ deployItem.huntPackage.severity }}</severity
                >
                <deploy>
                  <div *ngIf="outdated">
                    <div class="changelog">
                      <button
                        themeColor="primary"
                        (click)="openChangeLog()"
                        kendoButton
                      >
                        Change Log
                      </button>
                    </div>
                    <button
                      themeColor="primary"
                      (click)="markAsDeployed(deployItem.huntPackageUUID)"
                      kendoButton
                    >
                      Re-Deploy
                    </button>
                  </div>
                  <div *ngIf="deployItem.deployedAt && !outdated">
                    <button
                      fillMode="outline"
                      themeColor="primary"
                      (click)="removeDeployed(deployItem.huntPackageUUID)"
                      kendoButton
                    >
                      Remove from Deployed
                    </button>
                  </div>
                  <ng-template [ngIf]="!deployItem.deployedAt">
                    <button
                      fillMode="outline"
                      themeColor="primary"
                      (click)="removeDeployed(deployItem.huntPackageUUID)"
                      kendoButton
                    >
                      Unstage
                    </button>
                    &nbsp;
                    <button
                      themeColor="primary"
                      (click)="markAsDeployed(deployItem.huntPackageUUID)"
                      kendoButton
                    >
                      Mark as Deployed
                    </button>
                  </ng-template>
                </deploy>
              </header-options>
            </package-header>
            <package-description>
              {{ deployItem.huntPackage.description }}
              <ul>
                <li *ngIf="deployItem.huntPackage.created_date != null">
                  <span>Created</span>
                  <p>
                    {{ deployItem.huntPackage.created_date | date: 'longDate' }}
                  </p>
                </li>
                <li *ngIf="deployItem.huntPackage.last_updated null">
                  <span>Updated</span>
                  <p>
                    {{ deployItem.huntPackage.last_updated | date: 'longDate' }}
                  </p>
                </li>
                <li *ngIf="deployItem.deployedAt">
                  <span>Deployed</span>
                  <p>{{ deployItem.deployedAt | date: 'longDate' }}</p>
                </li>
                <li
                  *ngIf="
              deployItem.huntPackage.mapping?.mitre?.mitre_attack_tactics.length != 0
              "
                >
                  <span>MITRE TACTICS</span>
                  <p>
                    {{
                    deployItem.huntPackage.mapping.mitre?.mitre_attack_tactics.join(
                    ', ' ) }}
                  </p>
                </li>
                <li
                  *ngIf="
              deployItem.huntPackage.mapping?.mitre?.mitre_attack_techniques.length != 0
              "
                >
                  <span>MITRE TECHNIQUES</span>
                  <p>
                    {{
                    deployItem.huntPackage.mapping?.mitre?.mitre_attack_techniques.join(
                    ', ' ) }}
                  </p>
                </li>
              </ul>
              <div class="col-lg-12">
                <kendo-tabstrip #tabstrip [animate]="true">
                  <kendo-tabstrip-tab
                    *ngFor="let content of compatibleContent"
                    title="{{ content.tool }} - {{ content.goal}} - {{ content.deployment_requirements.categories.join(', ') }}"
                  >
                    <ng-template kendoTabContent>
                      <content-tab>
                        <button
                          fillMode="outline"
                          themeColor="primary"
                          (click)="openContentDetails(content)"
                          kendoButton
                        >
                          View Details
                        </button>
                        <button
                          themeColor="primary"
                          (click)="openDeployContent(content)"
                          kendoButton
                        >
                          View Content
                        </button>
                      </content-tab>
                    </ng-template>
                  </kendo-tabstrip-tab>
                  <!-- </div> -->
                </kendo-tabstrip>
              </div>
            </package-description>
          </div>
        </div>
      </div>
    </mat-drawer-container>
  </kendo-card-body>
</kendo-card>
